<template>
  <div class="link-dialog-bg">
    <div class="link-dialog">
      <div class="close" @click="clickClose" />
      <div class="tip">
        <div>电脑壁纸需在元气桌面电脑版中使用</div>
        <div>请复制链接, 在电脑浏览器打开并下载</div>
      </div>
      <div class="btn" @click="clickCopy">
        点击复制下载链接
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkDialog',
  data() {
    return {
    }
  },
  methods: {
    copyText(text, success = null, fail = null) {
      text = text.replace(/(^\s*)|(\s*$)/g, '')
      if (!text) {
        typeof fail === 'function' && fail('复制的内容不能为空！')
        return
      }
      const id = 'the-clipboard'
      /**
       * 粘贴板节点
       * @type {HTMLTextAreaElement}
       */
      let clipboard = document.getElementById(id)
      if (!clipboard) {
        clipboard = document.createElement('textarea')
        clipboard.id = id
        clipboard.readOnly = true
        clipboard.style.cssText
          = 'font-size: 15px; position: fixed; top: -1000%; left: -1000%;'
        document.body.appendChild(clipboard)
      }
      clipboard.value = text
      clipboard.select()
      clipboard.setSelectionRange(0, text.length)
      const state = document.execCommand('copy')
      if (state) {
        typeof success === 'function' && success()
      } else {
        typeof fail === 'function' && fail('复制失败')
      }
    },
    clickCopy() {
      this.copyText('https://desk.duba.com/')
      this.$toast('链接已复制~')
      this.$emit('close', false)
    },
    clickClose() {
      this.$emit('close', false)
    },
  },
}
</script>

<style scoped lang="scss">
.link-dialog-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 99;
    .link-dialog {
     width: 3rem;
     height: 1.78rem;
     background: #FFFFFF;
     border-radius: 10px;
     border-radius: 10px;
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translateX(-50%) translateY(-50%);
     display: flex;
     align-items: center;
     flex-direction: column;
 }
 .close {
    position: absolute;
    top: .08rem;
    right: .06rem;
    width: 25px;
    height: 25px;
    background: url('~@/assets/images/gray_close.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
 }
}
.tip {
    margin-top: 0.4rem;
    font-size: 15px;
    text-align: center;
}
.btn {
    width: 2.5rem;
    height: .44rem;
    line-height: .44rem;
    text-align: center;
    background: linear-gradient(90deg, #FFDA56 0%, #FACA2A 100%);
    border-radius: 10px;
    font-size: 15px;
    color: #333;
    margin-top: .25rem;
}
</style>
